import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { STEPS } from 'constants/constants';
import type { CandidateJobAssignment } from 'store/reducers/candidateReducer';

export interface JobAssignedRow {
  id: string;
  job_step: { job: string; step: string; link: string };
  status?: string;
  recruiter: string | null;
  team_lead: string;
  /* Rendered as a generic Table row: columns read cells by dynamic key. */
  [key: string]: unknown;
}

export const useJobAssignedData = (jobs: CandidateJobAssignment[]): JobAssignedRow[] => {
  const { id: candidateId } = useParams<{ id: string }>();
  return useMemo(
    () =>
      jobs.map(job => ({
        id: job.job_uuid,
        job_step: {
          job: job.job,
          step: `${STEPS.findIndex(s => s.value === job.active_step?.name) + 1 || ''} - ${job.active_step?.name || ''}`,
          link: `/jobs/${job.job_uuid}/show/${
            job.active_step ? `steps/${job.active_step.uuid}/${candidateId}` : 'hired'
          }`,
        },
        status: job.active_step?.step_status || job.candidate_status,
        recruiter: job.responsible_recruiter,
        team_lead: job.team_lead,
      })),
    [jobs]
  );
};
